import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import FAQ from './FAQ';
import Wallet from './Wallet';

export default function FAQPage() {
  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 70px)',
        background: '#0F2E2B',
        position: 'relative',
        overflow: 'hidden',
        py: 0,
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background: `
            radial-gradient(650px 450px at 85% -10%, rgba(212,162,76,0.14), transparent 60%),
            radial-gradient(550px 450px at -10% 80%, rgba(47,143,118,0.18), transparent 60%)
          `,
          zIndex: 0,
          pointerEvents: 'none',
        },
      }}
    >
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>

        {/* Content Sections: FAQ first, then Wallet */}
        <Box>
          <FAQ />
          <Wallet />
        </Box>
      </Container>
    </Box>
  );
}
